// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container .setCode[data-v-d8a302f6] {\n  margin: 20px;\n}\n.container .titleImg[data-v-d8a302f6] {\n  position: relative;\n}\n.container .titleImg .toCode[data-v-d8a302f6] {\n    position: absolute;\n    top: 58%;\n    left: 6%;\n    width: 190px;\n    height: 60px;\n    cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
